import { Center, Loader } from '@mantine/core';
import { createFileRoute } from '@tanstack/react-router';
import { errorMessage } from '@/api/errors';
import { useMission } from '@/api/missions';
import { EmptyState } from '@/components/EmptyState';
import { PlannerPage } from '@/features/missions/PlannerPage';

export const Route = createFileRoute('/_staff/staff/missions/$missionId')({ component: MissionPage });

function MissionPage() {
  const { missionId } = Route.useParams();
  const { data, isPending, isError, error } = useMission(missionId);
  if (isPending) {
    return (
      <Center py="xl">
        <Loader color="forest" />
      </Center>
    );
  }
  if (isError || !data) return <EmptyState title={errorMessage(error)} />;
  // Keyed so a different mission remounts the page with fresh local state.
  return <PlannerPage key={data.public_id} mission={data} />;
}
